// 🚨🚨🚨 CUSTOM jQuery code via https://websensepro.com/blog/how-to-add-custom-newsletter-popup-in-shopify-without-any-app/
// Purpose =  to show dialog once on page load
// Triggers =  atendpage | onload | onidle
// Animations= fade | flyInRight | flyInLeft | flyInUp | flyInDown
// See section custom-region-selector-splash.liquid
// Last updated on 28/11/24 by Jaye Gyesie

// !(function (o) {
//   var n = {
//     trigger: "onload",
//     animation: "fade",
//     delay: 100,
//     showOnce: !1,
//     autoClose: !1,
//     scrollableModal: !1,
//   };
//   o.fn.countrysplash = function (s) {
//     var e = o.extend({}, n, s),
//       i = o(this),
//       a = !1,
//       l = !1;
//     switch (
//       (i.addClass("sb"),
//       (o.fn.openWindow = function () {
//         o(this).is(":hidden") &&
//           !1 == a &&
//           !1 == l &&
//           ((l = !0),
//           setTimeout(function () {
//             !0 == e.scrollableModal
//               ? o(".sb-overlay").length < 1 &&
//                 (o("body").append(
//                   "<div class='sb-overlay'><div class='sb-close-backdrop'></div><div class='sb sb-withoverlay'>" +
//                     o(".sb").html() +
//                     "</div></div>"
//                 ),
//                 o(".sb-close-backdrop, .sb-close-btn").one(
//                   "click",
//                   function () {
//                     return o(".sb.sb-withoverlay").closeWindow(), !1;
//                   }
//                 ),
//                 o(".sb.sb-withoverlay")
//                   .removeClass(
//                     "sb-animation-" + e.animation.replace("In", "Out")
//                   )
//                   .addClass("sb-animation-" + e.animation),
//                 setTimeout(function () {
//                   o(".sb.sb-withoverlay").show(),
//                     o("body").addClass("sb-open sb-open-with-overlay");
//                 }, 300))
//               : o(".sb-overlay").length < 1 &&
//                 (o("body").append(
//                   "<div class='sb-overlay'><div class='sb-close-backdrop'></div></div>"
//                 ),
//                 o(".sb")
//                   .removeClass(
//                     "sb-animation-" + e.animation.replace("In", "Out")
//                   )
//                   .addClass("sb-animation-" + e.animation),
//                 o(".sb-close-backdrop, .sb-close-btn").one(
//                   "click",
//                   function () {
//                     return o(".sb").closeWindow(), !1;
//                   }
//                 ),
//                 setTimeout(function () {
//                   o(".sb").show(), o("body").addClass("sb-open");
//                 }, 300)),
//               !0 == e.showOnce && (a = !0),
//               (l = !1);
//           }, e.delay));
//       }),
//       (o.fn.closeWindow = function () {
//         o(this).is(":visible") &&
//           !1 == l &&
//           ((l = !0),
//           !0 == e.scrollableModal
//             ? (o(".sb.sb-withoverlay")
//                 .removeClass("sb-animation-" + e.animation)
//                 .addClass("sb-animation-" + e.animation.replace("In", "Out")),
//               setTimeout(function () {
//                 o(".sb.sb-withoverlay").hide(),
//                   o("body").removeClass("sb-open sb-open-with-overlay"),
//                   setTimeout(function () {
//                     o(".sb-overlay").remove();
//                   }, 300);
//               }, 300))
//             : (o(".sb")
//                 .removeClass("sb-animation-" + e.animation)
//                 .addClass("sb-animation-" + e.animation.replace("In", "Out")),
//               setTimeout(function () {
//                 o(".sb").hide(),
//                   o("body").removeClass("sb-open"),
//                   setTimeout(function () {
//                     o(".sb-overlay").remove();
//                   }, 300);
//               }, 300)),
//           (l = !1));
//       }),
//       (o.fn.scrollDetection = function (n, s) {
//         var e,
//           i = new Date().getTime();
//         o(window).scroll(function () {
//           var n = new Date().getTime();
//           n - i > 400 && (o(this).trigger("scrollStart"), (i = n)),
//             clearTimeout(e),
//             (e = setTimeout(function () {
//               o(window).trigger("scrollEnd");
//             }, 300));
//         }),
//           "scrollStart" == n &&
//             o(window).bind("scrollStart", function () {
//               o(window).unbind("scrollEnd"), s();
//             }),
//           "scrollEnd" == n &&
//             o(window).bind("scrollEnd", function () {
//               o(window).unbind("scrollStart"), s();
//             });
//       }),
//       e.trigger)
//     ) {
//       case "atendpage":
//         o(window).scroll(function () {
//           var n = o(window).scrollTop();
//           n >= o(document).height() - o(window).height()
//             ? i.openWindow()
//             : n + 300 < o(document).height() - o(window).height() &&
//               !0 == e.autoClose &&
//               i.closeWindow();
//         });
//         break;
//       case "onload":
//         o(window).on("load", function () {
//           i.openWindow(),
//             !0 == e.autoClose &&
//               i.scrollDetection("scrollStart", function () {
//                 i.closeWindow();
//               });
//         });
//         break;
//       case "onidle":
//         o(window).on("load", function () {
//           i.scrollDetection("scrollEnd", function () {
//             i.openWindow();
//           }),
//             !0 == e.autoClose &&
//               i.scrollDetection("scrollStart", function () {
//                 i.closeWindow();
//               });
//         });
//     }
//   };
// })(window.jQuery);
// $(document).ready(function () {
//   "true" !== sessionStorage.countrySelectPopupShown &&
//     ($(".country-splash").countrysplash(),
//     (sessionStorage.countrySelectPopupShown = "true"));
// });

(function () {
  // Default configuration
  const defaults = {
    trigger: "onload",
    delay: 100,
    showOnce: true,
    autoClose: false,
  };

  class CountrySplash {
    constructor(options = {}) {
      // Merge default and user options
      this.config = { ...defaults, ...options };
      this.dialog = document.getElementById("countrySplashDialog");
      this.isShown = false;
      this.isProcessing = false;

      this.init();
    }

    init() {
      // Check if dialog should be shown
      if (this.shouldShow()) {
        this.setupTrigger();
      }
    }

    shouldShow() {
      // Check if dialog should be shown based on showOnce setting
      if (this.config.showOnce) {
        const wasShown = sessionStorage.getItem("countrySelectPopupShown");
        return wasShown !== "true";
      }
      return true;
    }

    setupTrigger() {
      switch (this.config.trigger) {
        case "atendpage":
          this.setupEndPageTrigger();
          break;
        case "onload":
          this.setupOnLoadTrigger();
          break;
        case "onidle":
          this.setupOnIdleTrigger();
          break;
        default:
          this.openDialog();
      }
    }

    setupEndPageTrigger() {
      window.addEventListener("scroll", () => {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const docHeight = Math.max(
          document.body.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.clientHeight,
          document.documentElement.scrollHeight,
          document.documentElement.offsetHeight
        );

        if (scrollTop >= docHeight - window.innerHeight) {
          this.openDialog();
        } else if (
          this.config.autoClose &&
          scrollTop + 300 < docHeight - window.innerHeight
        ) {
          this.closeDialog();
        }
      });
    }

    setupOnLoadTrigger() {
      window.addEventListener("load", () => {
        setTimeout(() => {
          this.openDialog();

          if (this.config.autoClose) {
            this.setupScrollDetection("scrollStart", () => {
              this.closeDialog();
            });
          }
        }, this.config.delay);
      });
    }

    setupOnIdleTrigger() {
      window.addEventListener("load", () => {
        this.setupScrollDetection("scrollEnd", () => {
          this.openDialog();
        });

        if (this.config.autoClose) {
          this.setupScrollDetection("scrollStart", () => {
            this.closeDialog();
          });
        }
      });
    }

    setupScrollDetection(type, callback) {
      let scrollTimer;
      let lastScrollTime = new Date().getTime();

      const scrollHandler = () => {
        const currentTime = new Date().getTime();

        if (currentTime - lastScrollTime > 400) {
          if (type === "scrollStart") {
            window.removeEventListener("scroll", scrollHandler);
            callback();
          }
          lastScrollTime = currentTime;
        }

        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          if (type === "scrollEnd") {
            window.removeEventListener("scroll", scrollHandler);
            callback();
          }
        }, 300);
      };

      window.addEventListener("scroll", scrollHandler);
    }

    openDialog() {
      // Prevent multiple opens
      if (this.isShown || this.isProcessing) return;

      this.isProcessing = true;

      // Open the dialog
      if (this.dialog) {
        this.dialog.showModal();
        this.dialog.style.display = "block";

        // Mark as shown if config requires
        if (this.config.showOnce) {
          sessionStorage.setItem("countrySelectPopupShown", "true");
          this.isShown = true;
        }

        this.isProcessing = false;
      }
    }

    closeDialog() {
      if (!this.dialog || this.isProcessing) return;

      this.isProcessing = true;
      this.dialog.close();
      this.dialog.style.display = "none";
      this.isProcessing = false;
    }
  }

  // Initialize on DOM ready
  document.addEventListener("DOMContentLoaded", () => {
    // Create an instance of CountrySplash
    new CountrySplash();
  });
})();
